import { Injectable } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { firstValueFrom } from 'rxjs'
import { ConfirmDialogComponent } from '../../components/confirm-dialog/confirm-dialog.component'
import { ConfirmDialogData } from '../../components/confirm-dialog/confirm-dialog.type'
import { FlagsService } from '../flags/flags.service'

@Injectable({
  providedIn: 'root',
})
export class ConfirmDialogService {
  public constructor(
    private readonly matDialog: MatDialog,
    private readonly flagsService: FlagsService
  ) { }

  public async open(data: ConfirmDialogData): Promise<boolean> {
    if (data.dontShowAgainFlag) {
      const dontShowAgain = this.flagsService.getFlag(data.dontShowAgainFlag)

      if (dontShowAgain) {
        return true
      }
    }

    const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
      data,
      panelClass: 'rounded-container',
      disableClose: true
    })

    return firstValueFrom(dialogRef.afterClosed())
  }
}
